import { render } from "./ElectionVoteSummaryView.vue?vue&type=template&id=4735aa5b&scoped=true"
import script from "./ElectionVoteSummaryView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteSummaryView.vue?vue&type=script&lang=js"

import "./ElectionVoteSummaryView.vue?vue&type=style&index=0&id=4735aa5b&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4735aa5b"]])

export default __exports__